import { motion } from "framer-motion";

export default function IFHeading({ children, as = "h2" }) {
    const HeadingTag = as === "h1" ? "h1" : "h2";

    return (
        <div className="flex justify-center items-center py-6 md:py-10 w-full overflow-hidden relative">
            <div className="flex items-center justify-center w-full max-w-[1400px] px-4 gap-3 md:gap-6">
                {/* Left Glowing Laser Line (Linear) */}
                <motion.div
                    initial={{ scaleX: 0, opacity: 0 }}
                    whileInView={{ scaleX: 1, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "linear" }}
                    className="flex-1 h-[2px] origin-right bg-gradient-to-r from-transparent via-[rgba(234,42,94,0.3)] to-pink"
                />

                {/* Central Title (Zero Blur, Linear) */}
                <motion.div
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.1, ease: "linear" }}
                    whileHover={{ scale: 1.03 }}
                >
                    <div className="px-5 md:px-8 py-2 md:py-3 rounded-full border border-pink/40 bg-[#12141e]">
                        <HeadingTag className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-black tracking-wider text-center uppercase m-0 bg-gradient-to-r from-white via-white to-pink bg-clip-text text-transparent">
                            {children}
                        </HeadingTag>
                    </div>
                </motion.div>

                {/* Right Glowing Laser Line (Linear) */}
                <motion.div
                    initial={{ scaleX: 0, opacity: 0 }}
                    whileInView={{ scaleX: 1, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "linear" }}
                    className="flex-1 h-[2px] origin-left bg-gradient-to-r from-pink via-[rgba(234,42,94,0.3)] to-transparent"
                />
            </div>
        </div>
    );
}

export { IFHeading as IF_Heading };
